import { Router } from "./Components/Routes";
import "./App.scss";
function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
